export default "/images/75b272d93ef3dff871a94f6e5b10d7f3.jpg";